import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';

export default class ScheduledPost extends Discussion {
	content() {
		return Model.attribute<string>('content').call(this);
	}

	scheduledAt() {
		return Model.attribute<Date | undefined, string | undefined>('scheduledAt', Model.transformDate).call(this);
	}
}
